import React from 'react';
import { Card, Avatar, Tag } from "antd";
import {
    UserOutlined,
    PhoneOutlined,
    MailOutlined,
    GlobalOutlined,
    CalendarOutlined
} from "@ant-design/icons";
import { capitalizeFirstLetter, formatDateTime } from "../../../../../../utils/functions";

const EnhancedLeadNotSendDetailsCardView = ({
    record,
}) => {
    // Helper to get initials or icon for avatar
    const getAvatarContent = () => {
        return <UserOutlined />;
    };

    const fullName = record.fullName ? record.fullName : `${record.firstName} ${record.lastName}`;

    return (
        <Card
            hoverable
            className="h-full cursor-auto"
        >
            <div className="space-y-4">
                {/* Header: Name and Destination */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3">
                        <Avatar
                            size={48}
                            className="flex-shrink-0 font-semibold text-lg !bg-primary"
                            icon={getAvatarContent()}
                        />
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate text-primary" title={fullName}>
                                {fullName}
                            </h3>
                            <Tag color="blue">
                                <span className="flex items-center gap-1">
                                    <GlobalOutlined />
                                    {capitalizeFirstLetter(record.destination)}
                                </span>
                            </Tag>
                        </div>
                    </div>
                </div>

                {/* Info Details */}
                <div className="space-y-2 border-t border-gray-200 pt-3">
                    {/* Phone */}
                    <div className="flex items-center text-sm text-gray-600">
                        <PhoneOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate">{record.phone || 'N/A'}</span>
                    </div>

                    {/* Email */}
                    <div className="flex items-center text-sm text-gray-600">
                        <MailOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.email}>{record.email || 'N/A'}</span>
                    </div>

                    {/* Imported At */}
                    <div className="flex items-center text-sm text-gray-600">
                        <CalendarOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate">Imported: {formatDateTime(record.importedAt)}</span>
                    </div>
                </div>
            </div>
        </Card>
    );
}

export default EnhancedLeadNotSendDetailsCardView;